/**
 * @function collectBrowserInfo
 *
 * @desc Collects available frontend browser info
 * and store it in the properties dictated by the EMVCo spec
 * (3DS_Spec_protocolAndCoreFny_v2-1_Oct2017.pdf)
 *
 * @example const browserInfo = collectBrowserInfo();
 * const userAgent = browserInfo.userAgent;
 *
 * @returns {Object} - browserInfo an object containing the retrieved browser properties
 */
/* eslint-disable */
const collectBrowserInfo = () => {

    const screenWidth = window && window.screen ? window.screen.width : 1;
    const screenHeight = window && window.screen ? window.screen.height : 1;
    const colorDepth = window && window.screen ? window.screen.colorDepth : 16;
    const userAgent = window && window.navigator ? window.navigator.userAgent : '_';
    const javaEnabled = window && window.navigator ? navigator.javaEnabled() : false;

    let language = 'ru';
    if (window && window.navigator) {
        language = window.navigator.language
            ? window.navigator.language
            : window.navigator.browserLanguage; // Else is for IE <+ 10
    }

    const timeZoneOffset = new Date().getTimezoneOffset();

    const browserInfo = {
        'version': window.settings.threeDSV2.version,
        'device.channel': 'BRW',
        // 'device.browserAcceptHeader': 'text/html',
        'device.browserScreenWidth': screenWidth,
        'device.browserScreenHeight': screenHeight,
        'device.browserColorDepth': colorDepth,
        'device.browserUserAgent': userAgent,
        'device.browserTZ': timeZoneOffset,
        'device.browserLanguage': language,
        'device.browserJavaEnabled': javaEnabled,
        'challengeWindowSize': '04'
    };

    return browserInfo;
};

export default collectBrowserInfo;
